import FormContainer from './components/Form.container';

const Form = ({ match, location, history }) => (
  <FormContainer match={match} location={location} history={history} />
);

export default Form;
